/**
 * EPS-5027: Ana bayi, kendisine bağlı bir alt bayinin paneline yeni sekmede giriş yapabiliyor.
 *
 * Token `localStorage`'da tutulsaydı yeni sekmede yazılan alt bayi token'ı, aynı origin'i
 * paylaşan ana bayi sekmesinin oturumunu da sessizce ezerdi. Bu yüzden alt bayi oturumu
 * sekmeye özel olan `sessionStorage`'da tutuluyor; normal oturum eskisi gibi `localStorage`'da.
 *
 * Kural: `sessionStorage`'da token varsa o sekme bir alt bayi oturumudur ve oturuma ait tüm
 * değerler (token, merchantId) oradan okunup oraya yazılır.
 */
const authStorage = () =>
  sessionStorage.getItem("token") ? sessionStorage : localStorage;

export const isSubMerchantSession = () =>
  Boolean(sessionStorage.getItem("token"));

export const getToken = () => authStorage().getItem("token");

export const setToken = (token) => authStorage().setItem("token", token);

export const startSubMerchantSession = (token) =>
  sessionStorage.setItem("token", token);

export const clearToken = () => authStorage().removeItem("token");

export const getMerchantId = () => authStorage().getItem("merchantId");

export const setMerchantId = (merchantId) =>
  authStorage().setItem("merchantId", merchantId);
